import { clientBaseUrl, webApiBaseUrl } from "../constants";

export default class UrlHelper {
  public static fullApiUrl(uri: string, id?: string): string {
    const rasterizedUri = id ? uri.replace("{id}", id) : uri;
    return webApiBaseUrl + rasterizedUri;
  }

  public static fullClientUrl(uri: string, id?: string): string {
    const rasterizedUri = id ? uri.replace("{id}", id) : uri;
    return clientBaseUrl + rasterizedUri;
  }
}
